const timeZone = "America/Los_Angeles";
const yearFormatter = new Intl.DateTimeFormat("en-US", { timeZone, year: "numeric" });
const currentYearFormatter = new Intl.DateTimeFormat("en-US", { timeZone, month: "long", day: "numeric" });
const otherYearFormatter = new Intl.DateTimeFormat("en-US", { timeZone, month: "short", day: "numeric", year: "numeric" });

/** Calendar labels use Pacific Time for both the displayed day and year comparison. */
export function formatCalendarDate(date: Date, now = new Date()): string {
  return yearFormatter.format(date) === yearFormatter.format(now)
    ? currentYearFormatter.format(date)
    : otherYearFormatter.format(date);
}

const numericFormatter = new Intl.DateTimeFormat("en-US", { timeZone, month: "2-digit", day: "2-digit", year: "numeric" });

export function formatNumericCalendarDate(date: Date): string {
  return numericFormatter.format(date);
}
